import React, { useEffect, useState } from "react";
import "../assets/css/Area.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";

const SurveyForm = () => {
  const [formData, setFormData] = useState({
    branch: "",
    surveyDate: "",
    employee: "",
    areaName: "",
    villageName: "",
    population: "",
    political: "",
    lawOrder: "",
    distance: "",
    centersPossible: "",
    mfiWorking: "",
    mfiName: "",
  majorOperation: "",
    roadStatus: "",
    religion: { hindu: "", muslim: "", sikh: "", christian: "", other: "" },
    caste: { general: "", obc: "", sc: "", st: "", other: "" },
    remarks: "",
  });

  const {profile}=useSelector((state)=>state.userProfile);
  const dispatch=useDispatch();
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // console.log("profile",profile)

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes("religion.")) {
      const key = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        religion: { ...prev.religion, [key]: value },
      }));
    } else if (name.includes("caste.")) {
      const key = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        caste: { ...prev.caste, [key]: value },
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log("Survey Form Data:", formData);
  //   alert("Survey data submitted successfully!");
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    branch_id: Number(profile.branchId),
    employee_id: Number(profile.id),
    superAdmin: Number(profile.superAdminId)||14,
    surveyDate: formData.surveyDate,
    areaName: formData.areaName,
    villageName: formData.villageName,
    populationOfVillage: Number(formData.population),
    politicalSituation: formData.political,
    lawAndOrderSituation: formData.lawOrder,
    distanceFromBranch: formData.distance,
    possibleCenters: Number(formData.centersPossible),
    mfiWorking: Number(formData.mfiWorking),
    mfiNames: formData.mfiName,
    majorOperationPeople: formData.majorOperation,
    roadStatus: formData.roadStatus,

    // religion nested
    hinduReligionPercentage: Number(formData.religion.hindu),
    muslimReligionPercentage: Number(formData.religion.muslim),
    sikhReligionPercentage: Number(formData.religion.sikh),
    christianReligionPercentage: Number(formData.religion.christian),
    otherReligionPercentage: Number(formData.religion.other),

    // caste nested
    generalCastPercentage: Number(formData.caste.general),
    obcCastPercentage: Number(formData.caste.obc),
    scCastPercentage: Number(formData.caste.sc),
    stCastPercentage: Number(formData.caste.st),
    otherCastPercentage: Number(formData.caste.other),

    latitude: "26.8467",  // add tracking if GPS user se lena ho
    longitude: "80.9462",
    ipAddress: "127.0.0.1", 

    remarks: formData.remarks || "",
  };

  console.log("Final Payload =>", payload);

try {
  const res = await axios.post("https://narrowitsolution.in/api/create-area-survay", payload);
  alert(res.data?.message || "Survey Added");
  setFormData(
    {
      branch: "",
    surveyDate: "",
    employee: "",
    areaName: "",
    villageName: "",
    population: "",
    political: "",
    lawOrder: "",
    distance: "",
    centersPossible: "",
    mfiWorking: "",
    mfiName: "",
  majorOperation: "",
    roadStatus: "",
    religion: { hindu: "", muslim: "", sikh: "", christian: "", other: "" },
    caste: { general: "", obc: "", sc: "", st: "", other: "" },
    remarks: "",
    }
  )
} catch (err) {
 toast.error(err.response?.data?.message || "Failed to create survey");
}
};


  return (
    <div className="survey-form-wrapper">
      <form className="survey-form" onSubmit={handleSubmit}>
        <h2 className="surveysf-title">Area Survey</h2>

        {/* ======================== BASIC DETAILS ======================== */}
        <div className="surveygrid-3">
          {/* <div className="surveyfield">
            <span>Branch</span>
            <select name="branch" value={formData.branch} onChange={handleChange}>
              <option value="">-- Select Branch --</option>
              <option>Patna</option>
              <option>Gaya</option>
              <option>Muzaffarpur</option>
            </select>
          </div> */}

          <div className="surveyfield">
            <label>Survey Start Date</label>
            <input
              type="date"
              name="surveyDate"
              value={formData.surveyDate}
              onChange={handleChange}
            />
          </div>

          {/* <div className="surveyfield">
            <span>Employee</span>
            <select name="employee" value={formData.employee} onChange={handleChange}>
              <option value="">-- Select Employee --</option>
              <option>Ravi Kumar</option>
              <option>Neha Singh</option>
              <option>Amit Verma</option>
            </select>
          </div> */}

           <div className="surveyfield">
            <label>Area Name</label>
            <input
              type="text"
              name="areaName"
              value={formData.areaName}
              onChange={handleChange}
            />
          </div>

          <div className="surveyfield">
            <label>Village Name</label>
            <input
              type="text"
              name="villageName"
              value={formData.villageName}
              onChange={handleChange}
            />
          </div>

          <div className="surveyfield">
            <label>Population of Village</label>
            <input
              type="number"
              name="population"
              value={formData.population}
              onChange={handleChange}
            />
          </div>

          <div className="surveyfield">
            <label>Political Situation</label>
            <input
              type="text"
              name="political"
              value={formData.political}
              onChange={handleChange}
            />
          </div>

          <div className="surveyfield">
            <label>Law & Order Situation</label>
            <select name="lawOrder" value={formData.lawOrder} onChange={handleChange}>
              <option value="">-- Select Law & Order --</option>
              <option>Good</option>
              <option>Average</option>
              <option>Poor</option>
            </select>
          </div>

          <div className="surveyfield">
            <label>Distance from Branch (km)</label>
            <input
              type="number"
              name="distance"
              value={formData.distance}
              onChange={handleChange}
            />
          </div>

          <div className="surveyfield">
            <label>No. of Centres Possible</label>
            <input
              type="number"
              name="centersPossible"
              value={formData.centersPossible}
              onChange={handleChange}
            />
          </div>

          <div className="surveyfield">
            <label>No. of MFI Working</label>
            <input
              type="number"
              name="mfiWorking"
              value={formData.mfiWorking}
              onChange={handleChange}
            />
          </div>

          <div className="surveyfield">
            <label>Name of MFI</label>
            <input
              type="text"
              name="mfiName"
              value={formData.mfiName}
              onChange={handleChange}
            />
          </div>

           <div className="surveyfield">
            <label>Major Operation</label>
            <input
              type="text"
              name="majorOperation"
              value={formData.majorOperation}
              onChange={handleChange}
            />
          </div>

          <div className="surveyfield">
            <label>Road Status</label>
            <select name="roadStatus" value={formData.roadStatus} onChange={handleChange}>
              <option value="">-- Select Road Status --</option>
              <option>Good</option>
              <option>Moderate</option>
              <option>Poor</option>
            </select>
          </div>
        </div>

        {/* <div className="surveygrid-2">
         
        </div> */}

        {/* ======================== RELIGION & CASTE SIDE BY SIDE ======================== */}
<div className="surveygrid-2 card-pair">
  {/* Religion Section */}
  <div className="surveycard-section">
    <h3>Religion in Percentage (%)</h3>
    <div className="inner-surveygrid-3">
      <div className="surveyfield">
        <span>Hindu</span>
        <input
          type="number"
          name="religion.hindu"
          value={formData.religion.hindu}
          onChange={handleChange}
        />
      </div>
      <div className="surveyfield">
        <span>Muslim</span>
        <input
          type="number"
          name="religion.muslim"
          value={formData.religion.muslim}
          onChange={handleChange}
        />
      </div>
      <div className="surveyfield">
        <span>Sikh</span>
        <input
          type="number"
          name="religion.sikh"
          value={formData.religion.sikh}
          onChange={handleChange}
        />
      </div>
    </div>

    <div className="surveygrid-2">
      <div className="surveyfield">
        <span>Christian</span>
        <input
          type="number"
          name="religion.christian"
          value={formData.religion.christian}
          onChange={handleChange}
        />
      </div>
      <div className="surveyfield">
        <span>Other</span>
        <input
          type="number"
          name="religion.other"
          value={formData.religion.other}
          onChange={handleChange}
        />
      </div>
    </div>
  </div>

  {/* Caste Section */}
  <div className="surveycard-section">
    <h3>Caste in Percentage (%)</h3>
    <div className="inner-surveygrid-3">
      <div className="surveyfield">
        <span>General</span>
        <input
          type="number"
          name="caste.general"
          value={formData.caste.general}
          onChange={handleChange}
        />
      </div>
      <div className="surveyfield">
        <span>OBC</span>
        <input
          type="number"
          name="caste.obc"
          value={formData.caste.obc}
          onChange={handleChange}
        />
      </div>
      <div className="surveyfield">
        <span>SC</span>
        <input
          type="number"
          name="caste.sc"
          value={formData.caste.sc}
          onChange={handleChange}
        />
      </div>
    </div>

    <div className="surveygrid-2">
      <div className="surveyfield">
        <span>ST</span>
        <input
          type="number"
          name="caste.st"
          value={formData.caste.st}
          onChange={handleChange}
        />
      </div>
      <div className="surveyfield">
        <span>Other</span>
        <input
          type="number"
          name="caste.other"
          value={formData.caste.other}
          onChange={handleChange}
        />
      </div>
    </div>
  </div>
</div>


        {/* ======================== REMARKS & BUTTON ======================== */}
        <div className="surveyremarks-area">
          <label>
            <span>Remarks</span>
            <textarea
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
              className="surveytext"
            ></textarea>
          </label>
        </div>
          <div className="surveyactions">
            <button type="submit" className="surveybtn-add">
              Submit
            </button>
          </div>
      </form>
    </div>
  );
};

export default SurveyForm;
